// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_retailer_admin_mfe_styles" + "." + "22731640" + ".chunk.css";
};